import { Selector } from '@ngxs/store';
import { EventDetailOutputDto } from '@smatchy/sdk';
import {
  MyEventInvitationsState,
  MyEventInvitationsStateModel,
} from './my-event-invitations.state';

export class MyEventInvitationsSelector {
  @Selector([MyEventInvitationsState])
  static loading(state: MyEventInvitationsStateModel): boolean {
    return state.loading;
  }

  @Selector([MyEventInvitationsState])
  static invitations(state: MyEventInvitationsStateModel): EventDetailOutputDto[] {
    return state.invitations;
  }

  @Selector([MyEventInvitationsState])
  static hasInvitations(state: MyEventInvitationsStateModel): boolean {
    return state.invitations.length > 0;
  }

  @Selector([MyEventInvitationsState])
  static processingEventId(state: MyEventInvitationsStateModel): string | null {
    return state.processingEventId;
  }
}
